import { useStoredViewMode, VIEW_MODE, type ViewMode } from '@/shared/hooks';

export const LIBRARY_VIEW_MODE = VIEW_MODE;
export type LibraryViewMode = ViewMode;

const STORAGE_KEY = 'brand-media-library:view-mode';

/**
 * Cards, because the library is pictures first: someone arriving to find a photograph is looking at
 * the pictures, and the list is what they switch to when they want the metadata instead.
 */
const DEFAULT_MODE: LibraryViewMode = LIBRARY_VIEW_MODE.cards;

/** How the library is drawn, remembered per browser. */
export function useLibraryViewMode() {
  return useStoredViewMode(STORAGE_KEY, DEFAULT_MODE);
}
